export class ForesightConnection {
    ftpServerId = 0;
    articleFolder = "";
    manufacturerFolder = "";
    exportFileName ="";
}
